import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
} from '@mui/material';
import {
  Cancel as CancelIcon,
} from '@mui/icons-material';
import PageSection from '../components/PageSection';

const PaymentCancel: React.FC = () => {
  const navigate = useNavigate();

  const handleGoToBilling = () => {
    navigate('/billing');
  };

  return (
    <PageSection 
      title="Payment Cancelled"
      subtitle="Your payment was not processed."
      hideTitleOnMobile
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <Card sx={{ maxWidth: 500, width: '100%' }}>
          <CardContent sx={{ textAlign: 'center', py: 4 }}>
            <CancelIcon 
              sx={{ 
                fontSize: 80, 
                color: 'warning.main', 
                mb: 2 
              }} 
            />
            <Typography variant="h5" component="h2" gutterBottom>
              Payment Cancelled
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Your payment was cancelled. No charges were made to your account.
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              If you'd like to try again, you can return to the billing page and select a plan.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleGoToBilling}
              sx={{
                background: 'linear-gradient(135deg, #8b9cff 0%, #ff6b9d 100%)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #5a6fd8 0%, #d94f7e 100%)',
                },
              }}
            >
              Back to Billing
            </Button>
          </CardContent>
        </Card>
      </Box>
    </PageSection>
  );
};

export default PaymentCancel;

